import React from "react"; 

const ErrorLog = ({ error }) => {
  if (!error) return null;

  return (
    <div className="error-log">
      <h3>Error Log:</h3>
      <p>{error}</p>
    </div>
  );
};

export default ErrorLog;
